import React from "react";

export default function InfoModal() {
    return (
        <div className="modal moreInfo_modal fade" id="infoModal" tabIndex="-1" aria-labelledby="infoModalLabel"
            aria-hidden="true">
            <div className="modal-dialog moreInfo_modal-dialog">
                <div className="modal-content moreInfo_modal-content">
                    <div className="modal-header moreInfo_modal-header">
                        <h1 className="modal-title fs-5" id="infoModalLabel">Tracking flights</h1>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div className="modal-body moreInfo_modal-body">
                        <div className="body_text mb-4">
                            <h3>Why share your flight number?</h3>
                            <p>It helps us to track flight delays and adjust pickup accordingly.</p>
                        </div>
                    </div>
                    <div className="modal-footer moreInfo_modal-footer">
                        <button type="button" className="btn" data-bs-dismiss="modal">Understood</button>
                    </div>
                </div>
            </div>
        </div>
    );
}
